var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.logged)?[_c('top-bar'),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('left-menu'),_vm._v(" "),_c('div',{staticClass:"container-fluid",attrs:{"id":"page-content-wrapper"}},[_c('router-view')],1)],1)]:[_c('router-view')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fe5c59d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 600
// module chunks = 0